import * as actions from '../actions/index'

import { auth0 } from '../utils/Auth0'
import { talkdesk } from '../utils/Talkdesk'

//checks for Auth0 and Talkdesk token
export const loggedIn = () => {
  return auth0.loggedIn() || talkdesk.loggedIn()
}

//checks for Auth0 and Talkdesk token
const jwt = () => {
  if ( auth0.loggedIn() ) {
    return auth0.getToken()
  }
  else if ( talkdesk.loggedIn() ) {
    return talkdesk.getToken()
  }
  return null
}

export const fixTrailingSlashInPath = (path) => {
  if (!path.endsWith("/")) {
    path += "/"
  }
  return path
}

export const checkNextPropsPromise = (thisProps, nextProps, key) => {
  return thisProps[key] !== nextProps[key] && nextProps[key].settled && !nextProps[key].refreshing
}

export const checkNextPropsPromiseFulfilled = (thisProps, nextProps, key) => {
  return thisProps[key] !== nextProps[key] && nextProps[key].settled && !nextProps[key].refreshing && nextProps[key].fulfilled
}

///////////////////////////////////////////////
/////////// React Refetch (REST) //////////////
///////////////////////////////////////////////

export const connectDefault = {fetch: customFetch, buildRequest: customBuildRequest, handleResponse:customHandleResponse }

function customBuildRequest(mapping) {
  const { dispatch, handler, title, method, credentials, redirect, url, body, appJWT, ignore_error } = mapping
  const options = { method, credentials, redirect }

  options['headers'] =  {
                          "Authorization": `Bearer ${jwt()}`,
                          "Accept": "application/json",
                          "Content-Type": "application/json"
                        }

  if (appJWT) {
    options['headers']['Authorization'] = `Bearer ${appJWT}`
  }

  if (body) {
    options.body = JSON.stringify(body)
  }

  logRequest(url, options, title, body)

  dispatch(actions.setLoading(true))
  const req = new Request(url, options)
  req.dispatch = dispatch
  req.handler = handler
  req.title = title
  req.display_error = ignore_error === undefined || !ignore_error
  return req
}

function customFetch(input, init) {
  const { dispatch, handler, title, display_error } = input

  const req = new Request(input, init)
  return fetch(req).then(response => {
                         response.dispatch = dispatch
                         response.handler = handler
                         response.title = title
                         response.display_error = display_error
                         return response
                 }).catch(function(error) {
                         console.log(error)
                         dispatch(actions.setLoading(false))
                         if (display_error) {
                           logErrorResponse(dispatch, title, 0, '', '')
                         }
                         if (handler !== undefined) { handler(null, error) }
                 })

}

function customHandleResponse(response) {
  const { dispatch, handler, title, status, statusText, display_error } = response

  dispatch(actions.setLoading(false))

  if (status >= 200 && status < 300) {
    return response.text().then(
              text => {
                return new Promise((resolve, reject) => {
                                                    if (text.length > 0) { resolve(JSON.parse(text)) }
                                                    else { resolve() }
                                                    }).then( (p) => {
                                                            if (handler !== undefined) { handler(p) }
                                                            return p
                                                        }
                                                    )
              }
           )
  }
  else {
    return response.text().then(
              cause => {
                if (display_error) {
                  logErrorResponse(dispatch, title, status, statusText, cause)
                }
                return new Promise((resolve, reject) => {
                                            const error = new Error(cause)
                                            reject(error)
                                            if (handler !== undefined) { handler(null, error) }
                                           })
              }
           )
          //  if uncommented then the Promise will act as "resolved", instead of "rejected". But the Portal needs the "rejected" state to know when a request failed
          //  .catch(function (err) {
          //    return new Promise((resolve, reject) => {
          //                                reject(err)
          //                                if (handler !== undefined) { handler(null, err) }
          //                               })
          //  })
  }
}

//logs

function logRequest(endpoint, mapping, name, body) {
  const { method, headers } = mapping

  if (body) {
    console.log(name,{endpoint,method,headers,body})
  }
  else {
    console.log(name,{endpoint,method,headers})
  }
}

function logErrorResponse(dispatch, title, status, statusText, cause) {
  const msg = `Error on ${title} - ${status} ${statusText} - ${cause}`

  dispatch(actions.setMessage(msg))
}



// WEBPACK FOOTER //
// ./src/utils/utils.js